import React from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SelectField} from "./ZoneSelect.style";

export const ZoneSelect = ({
    value,
    onChange,
    disabled = false,
    mode = undefined,
    allowClear = false,
    showSearch = true,
    showTitle = true,
    showAllOption = false,
    marginBottom = "20px",
    placeholder = "",
    includeDeleted = false,
    zoneManagementId = null,
    cityId = null,
    cityName = null,
    optionFilter = () => true,
    showSyUser = false,
    initialCall = true,
    externalData = undefined,
    externalLoading = false,
    ...props
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    const useExternalData = externalData !== undefined;

    const [internalLoading, internalData] = useFetch({
        defaultDataValue: {rows: []},
        fetchFn: stores.operationOrganizationStore.getZoneList.bind(null, {
            paginate: false,
            includeDeleted,
            zoneManagementId,
            cityId,
            cityName
        }),
        dependencies: [includeDeleted, zoneManagementId, cityId, cityName],
        condition: !useExternalData,
        initialCall: useExternalData ? false : initialCall
    });

    const loading = useExternalData ? externalLoading : internalLoading;
    const zones = useExternalData ? externalData : internalData;

    const formatSyUsers = zone => zone?.syUsers?.map(user => user?.fullName)?.join(", ") || null;

    const renderSyUser = () => {
        if (!showSyUser) return null;
        if (!zones?.data) return null;
        if (!value) return null;
        const zone = zones?.data?.find(zone => zone?._id?.toString() === value?.toString());
        return (
            <div style={{fontSize: "12px", color: "gray"}}>
                SY : {formatSyUsers(zone) || "Bilinmiyor"}
            </div>
        );
    };

    return (
        <React.Fragment>
            {showTitle && <h5>{t("Bölge")}</h5>}
            <SelectField
                data-testid="zoneSelect"
                value={value}
                onChange={onChange}
                disabled={disabled || loading}
                mode={mode}
                loading={loading}
                allowClear={allowClear}
                showSearch={showSearch}
                placeholder={placeholder || t("Bölge seçiniz")}
                filterOption={(input, option) =>
                    option?.["data-zonename"]
                        ?.toLocaleLowerCase("TR-tr")
                        ?.indexOf(input?.toLocaleLowerCase("TR-tr")) >= 0
                }
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="zoneSelect_all_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {zones?.data &&
                    zones?.data?.length > 0 &&
                    arrayAlphabeticalSort([...zones?.data], "name")
                        ?.filter(optionFilter)
                        ?.map(zone => (
                            <SelectField.Option
                                key={zone._id}
                                value={zone._id}
                                data-testid="zoneSelect_option"
                                data-zonename={zone?.name}
                                style={{borderBottom: "1px solid #e0e0e0"}}
                            >
                                <div>{zone.name}</div>
                                <div style={{fontSize: "12px", color: "gray"}}>
                                    SY : {formatSyUsers(zone) || "Bilinmiyor"}
                                </div>
                            </SelectField.Option>
                        ))}
            </SelectField>
            {renderSyUser()}
        </React.Fragment>
    );
};
